import { makeImmutable } from "../../core";
export class ModifierItemPackagingFeeRequirement {
    constructor(params) {
        this.modifierTypeId = params.modifierTypeId;
        this.modifierItemTypeIds = params.modifierItemTypeIds;
        makeImmutable(this);
    }
    testProduct(_) {
        return false;
    }
    testModifier(modifierTypeId, modifierItemTypeId) {
        if (!this.modifierTypeId.eq(modifierTypeId)) {
            return false;
        }
        return this.modifierItemTypeIds.includes(modifierItemTypeId);
    }
}
